<template>
	<main>
		<div class="vx-row" v-if="mitra.length > 0">
			<div 
				v-for="(item, i) in mitra"
				:key="i"
				class="vx-col w-full md:w-1/2 lg:w-1/4 "
			>
				<router-link :to="`/sahabat-zx/${createSlugLink( (item.user ? item.user.name : item.name), item.id )}`">
				<vx-card class="mb-8" >
					<header 
						class="py-4 flex justify-center" 
						style="height: 6rem;overflow: auto;"
						:style="{ backgroundImage: `url('${imageLink(item)}')`, backgroundSize: 'cover' }"
					>
						<!-- <img v-if="item.user && item.user.file !== null" v-lazy="item.user.file" class="w-16 rounded-full " alt="" />
							<img v-else v-lazy="``" class="w-16 rounded-full" alt="" /> -->
					</header>
					<section class="py-4">
						<h3 class="text-center" style="height: 4rem;overflow: auto;"><strong class="text-primary">{{item.user ? item.user.name : item.name}}</strong></h3>
					</section>
				</vx-card>
				</router-link>
			</div>
		</div>
		<!-- Pagination -->
		<div v-if="mitra.length > 0">
			<div 
				class="flex justify-center"
			>
				<vs-button 
					v-for="(item, i) in totalPagination" 
					:key="i"
					@click.prevent="changeData(i + 1)"
					class="rounded-full mx-1 my-4"
				>
					{{ item }}
				</vs-button>	
			</div>
		</div>
		<!-- / -->
	</main>
</template>
<script>
	import defaultImage from '@/../public/assets/images/sahabat-zx/charity.svg';
	export default {
		props: ['mitra', 'totalPagination'],
		methods: {
			changeData(ind) {
				this.$emit('changeData', ind)
			},
			imageLink(item) {
				if(item.user && item.user.file != null) {
					return item.user.file;
				}

				return defaultImage;
			}
		}
	};
</script>